import { createLazyElement } from '@common/utils'
import rootRoute from '@features/rootNavigation/navigation/route'

const baseSegment = 'thank-you'

rootRoute.children.push({
  path: baseSegment,
  element: createLazyElement(() => import('../components/ThankYouPage'))
})
